'use client';

import { useCallback } from 'react';

import { useLanguage } from '@/contexts/LanguageContext';
import i18n from '@/i18n/config';

/**
 * Simple translation hook that uses i18next core + our LanguageContext for reactivity.
 * Bypasses react-i18next's internal context to avoid SSR/hydration issues in Next.js App Router.
 */
export function useT() {
  const { language } = useLanguage();

  // The dependency on language.code forces a re-render when language changes

  const t = useCallback(
    (key: string, options?: Record<string, unknown>) => {
      return i18n.t(key, options) as string;
    },
    [language.code],
  );

  return { t, language };
}
